export const countriesCode = [
  { code: "+1", flag: "🇺🇸", name: "United States", pattern: /^[2-9]\d{2}[2-9]\d{6}$/ },
  { code: "+7", flag: "🇷🇺", name: "Russia" },
  { code: "+20", flag: "🇪🇬", name: "Egypt" },
  { code: "+27", flag: "🇿🇦", name: "South Africa" },
  { code: "+30", flag: "🇬🇷", name: "Greece" },
  { code: "+31", flag: "🇳🇱", name: "Netherlands" },
  { code: "+32", flag: "🇧🇪", name: "Belgium" },
  { code: "+33", flag: "🇫🇷", name: "France" },
  { code: "+34", flag: "🇪🇸", name: "Spain" },
  { code: "+36", flag: "🇭🇺", name: "Hungary" },
  { code: "+39", flag: "🇮🇹", name: "Italy" },
  { code: "+40", flag: "🇷🇴", name: "Romania" },
  { code: "+41", flag: "🇨🇭", name: "Switzerland" },
  { code: "+43", flag: "🇦🇹", name: "Austria" },
  { code: "+44", flag: "🇬🇧", name: "United Kingdom" },
  { code: "+45", flag: "🇩🇰", name: "Denmark" },
  { code: "+46", flag: "🇸🇪", name: "Sweden" },
  { code: "+47", flag: "🇳🇴", name: "Norway" },
  { code: "+48", flag: "🇵🇱", name: "Poland" },
  { code: "+49", flag: "🇩🇪", name: "Germany" },
  { code: "+51", flag: "🇵🇪", name: "Peru" },
  { code: "+52", flag: "🇲🇽", name: "Mexico" },
  { code: "+53", flag: "🇨🇺", name: "Cuba" },
  { code: "+54", flag: "🇦🇷", name: "Argentina" },
  { code: "+55", flag: "🇧🇷", name: "Brazil" },
  { code: "+56", flag: "🇨🇱", name: "Chile" },
  { code: "+57", flag: "🇨🇴", name: "Colombia" },
  { code: "+58", flag: "🇻🇪", name: "Venezuela" },
  { code: "+60", flag: "🇲🇾", name: "Malaysia" },
  { code: "+61", flag: "🇦🇺", name: "Australia" },
  { code: "+62", flag: "🇮🇩", name: "Indonesia" },
  { code: "+63", flag: "🇵🇭", name: "Philippines" },
  { code: "+64", flag: "🇳🇿", name: "New Zealand" },
  { code: "+65", flag: "🇸🇬", name: "Singapore" },
  { code: "+66", flag: "🇹🇭", name: "Thailand" },
  { code: "+81", flag: "🇯🇵", name: "Japan" },
  { code: "+82", flag: "🇰🇷", name: "South Korea" },
  { code: "+84", flag: "🇻🇳", name: "Vietnam" },
  { code: "+86", flag: "🇨🇳", name: "China" },
  { code: "+90", flag: "🇹🇷", name: "Turkey" },
  { code: "+91", flag: "🇮🇳", name: "India" , pattern: /^[6-9]\d{9}$/},
  { code: "+92", flag: "🇵🇰", name: "Pakistan" , pattern: /^3\d{9}$/},
  { code: "+93", flag: "🇦🇫", name: "Afghanistan" },
  { code: "+94", flag: "🇱🇰", name: "Sri Lanka" },
  { code: "+95", flag: "🇲🇲", name: "Myanmar" },
  { code: "+98", flag: "🇮🇷", name: "Iran" },
  { code: "+211", flag: "🇸🇸", name: "South Sudan" },
  { code: "+212", flag: "🇲🇦", name: "Morocco" },
  { code: "+213", flag: "🇩🇿", name: "Algeria" },
  { code: "+216", flag: "🇹🇳", name: "Tunisia" },
  { code: "+218", flag: "🇱🇾", name: "Libya" },
  { code: "+220", flag: "🇬🇲", name: "Gambia" },
  { code: "+221", flag: "🇸🇳", name: "Senegal" },
  { code: "+222", flag: "🇲🇷", name: "Mauritania" },
  { code: "+223", flag: "🇲🇱", name: "Mali" },
  { code: "+225", flag: "🇨🇮", name: "Ivory Coast" },
  { code: "+230", flag: "🇲🇺", name: "Mauritius" },
  { code: "+233", flag: "🇬🇭", name: "Ghana" },
  { code: "+234", flag: "🇳🇬", name: "Nigeria" },
  { code: "+235", flag: "🇹🇩", name: "Chad" },
  { code: "+237", flag: "🇨🇲", name: "Cameroon" },
  { code: "+240", flag: "🇬🇶", name: "Equatorial Guinea" },
  { code: "+254", flag: "🇰🇪", name: "Kenya" },
  { code: "+255", flag: "🇹🇿", name: "Tanzania" },
  { code: "+256", flag: "🇺🇬", name: "Uganda" },
  { code: "+260", flag: "🇿🇲", name: "Zambia" },
  { code: "+263", flag: "🇿🇼", name: "Zimbabwe" },
  { code: "+268", flag: "🇸🇿", name: "Eswatini" },
  { code: "+290", flag: "🇸🇭", name: "Saint Helena" },
  { code: "+375", flag: "🇧🇾", name: "Belarus" },
  { code: "+420", flag: "🇨🇿", name: "Czech Republic" },
  { code: "+421", flag: "🇸🇰", name: "Slovakia" },
  { code: "+423", flag: "🇱🇮", name: "Liechtenstein" },
  { code: "+500", flag: "🇫🇰", name: "Falkland Islands" },
  { code: "+501", flag: "🇧🇿", name: "Belize" },
  { code: "+502", flag: "🇬🇹", name: "Guatemala" },
  { code: "+503", flag: "🇸🇻", name: "El Salvador" },
  { code: "+504", flag: "🇭🇳", name: "Honduras" },
  { code: "+505", flag: "🇳🇮", name: "Nicaragua" },
  { code: "+506", flag: "🇨🇷", name: "Costa Rica" },
  { code: "+507", flag: "🇵🇦", name: "Panama" },
  { code: "+509", flag: "🇭🇹", name: "Haiti" },
  { code: "+598", flag: "🇺🇾", name: "Uruguay" },
];
